export default __webpack_public_path__ + "static/stock-house-6b6902582aaba54376d6fd95642bc109.jpg";